define(function (require, exports, module) {
    const Transformer = require('game-data-pacemaker/js/load/transform/DataTransformTemplate');
    const GumboModel = require('../model/GumboModel');
    const TeamLineupHittingStatsModel = require('../model/TeamLineupHittingStatsModel');
    const ScheduleApiModel = require('../model/ScheduleApiModel');
    const ContentModel = require('../model/ContentModel');
    const LiesContentModel = require('../model/LiesContentModel');
    const CmsDapiArticleListModel = require('../model/CmsDapiArticleListModel');

    const gdxEnvs = {
        local: {
            domain: 'https://gd.mlb.com/'
        },
        dev: {
            domain: 'https://gd.mlb.com/'
        },
        qa: {
            domain: 'https://gd.qa.mlb.com/'
        },
        beta: {
            domain: 'https://gd.mlb.com/'
        },
        editorial: {
            domain: 'https://gd.mlb.com/'
        },
        prod: {
            domain: 'https://gd.mlb.com/'
        }
    };

    const cmsDapiEnvs = {
        local: {
            domain: 'https://dapi.cms.mlbinfra.com/v2/content/'
        },
        dev: {
            domain: 'https://dapi.cms-dev.mlbinfra.com/v2/content/'
        },
        qa: {
            domain: 'https://dapi.cms-qa.mlbinfra.com/v2/content/'
        },
        beta: {
            domain: 'https://dapi.cms.mlbinfra.com/v2/content/'
        },
        prod: {
            domain: 'https://dapi.cms.mlbinfra.com/v2/content/'
        }
    };

    const stitchEnvs = {
        local: {
            domain: 'https://bdfed.stitch.npd.mlbinfra.com/'
        },
        dev: {
            domain: 'https://bdfed.stitch.npd.mlbinfra.com/'
        },
        qa: {
            domain: 'https://bdfed.stitch.npd.mlbinfra.com/'
        },
        beta: {
            domain: 'https://bdfed.stitch.mlbinfra.com/'
        },
        prod: {
            domain: 'https://bdfed.stitch.mlbinfra.com/'
        }
    };

    const socketEnvs = {
        local: {
            domain: 'wss://ws.statsapi.mlb.com/'
        },
        dev: {
            domain: 'wss://ws.statsapi.mlb.com/'
        },
        qa: {
            domain: 'wss://ws.qa-statsapi.mlb.com/'
        },
        beta: {
            domain: 'wss://ws.statsapi.mlb.com/'
        },
        prod: {
            domain: 'wss://ws.statsapi.mlb.com/'
        }
    };

    const wsStatsApiEnvs = {
        local: {
            domain: 'https://ws.statsapi.mlb.com/'
        },
        dev: {
            domain: 'https://ws.statsapi.mlb.com/'
        },
        qa: {
            domain: 'https://ws.qa-statsapi.mlb.com/'
        },
        beta: {
            domain: 'https://ws.statsapi.mlb.com/'
        },
        prod: {
            domain: 'https://ws.statsapi.mlb.com/'
        }
    };

    return {
        defaults: {
            expires: 30,
            timeout: 30,
            namespace: '{gid}',
            mimetype: 'application/json',
            transformer: Transformer,
            domain: 'https://statsapi.mlb.com/',
            env: {
                local: {
                    domain: 'https://statsapi.mlb.com/'
                },
                dev: {
                    domain: 'https://statsapi.mlb.com/'
                },
                qa: {
                    domain: 'https://qa-statsapi.mlb.com/'
                },
                beta: {
                    domain: 'https://statsapi.mlb.com/'
                },
                prod: {
                    domain: 'https://statsapi.mlb.com/'
                }
            }
        },
        api: {
            pathTemplate: 'api/v1.1/game/{gid}/feed/live{differ}?language={site}{timecode}{pushUpdateId}',
            transformer: Transformer,
            vo: GumboModel,
            mimetype: 'application/json',
            timeout: 30,
            fetch: {
                cache: 'no-cache'
            },
            env: wsStatsApiEnvs
        },
        contentApi: {
            pathTemplate: 'api/v1/game/{gid}/content?language={site}',
            mimetype: 'application/json',
            expires: 300,
            vo: ContentModel,
            transformer: Transformer,
            env_editorial: {
                domain: 'https://beta-statsapi.mlb.com/'
            }
        },
        scheduleApi: {
            pathTemplate: 'api/v1/schedule?gamePk={gid}&language={site}&hydrate=story,xrefId,lineups,broadcasts(all),probablePitcher(note),game(tickets)&useLatestGames=true&fields=dates,games,teams,probablePitcher,note,id,dates,games,broadcasts,type,name,homeAway,isNational,dates,games,game,tickets,ticketType,ticketLinks,dates,games,lineups,homePlayers,awayPlayers,useName,lastName,primaryPosition,abbreviation,dates,games,xrefIds,xrefId,xrefType,story',
            mimetype: 'application/json',
            expires: 300,
            vo: ScheduleApiModel,
            transformer: Transformer,
            env_editorial: {
                domain: 'https://beta-statsapi.mlb.com/'
            }
        },
        homeTeamLineupHittingStats: {
            pathTemplate: 'api/v1/people?personIds={playerId}&season={yyyy}&hydrate=stats(group=hitting,type=season,season={yyyy},gameType={game_type:R})',
            timeout: 30,
            expires: 300,
            transformer: Transformer,
            vo: TeamLineupHittingStatsModel,
            mimetype: 'application/json'
        },
        awayTeamLineupHittingStats: {
            pathTemplate: 'api/v1/people?personIds={playerId}&season={yyyy}&hydrate=stats(group=hitting,type=season,season={yyyy},gameType={game_type:R})',
            timeout: 30,
            expires: 300,
            transformer: Transformer,
            vo: TeamLineupHittingStatsModel,
            mimetype: 'application/json'
        },
        homeAwayPitcherPostseasonPitchingStats: {
            pathTemplate: 'api/v1/people?personIds={playerId}&season={yyyy}&hydrate=stats(group=pitching,type=season,season={yyyy},gameType={game_type:P})',
            timeout: 30,
            expires: 300,
            transformer: Transformer,
            vo: TeamLineupHittingStatsModel,
            mimetype: 'application/json'
        },
        currentPitcherPostseasonPitchingStats: {
            pathTemplate: 'api/v1/people?personIds={playerId}&season={yyyy}&hydrate=stats(group=pitching,type=season,season={yyyy},gameType={game_type:P})',
            timeout: 30,
            expires: 300,
            transformer: Transformer,
            vo: TeamLineupHittingStatsModel,
            mimetype: 'application/json'
        },
        currentBatterPostseasonPitchingStats: {
            pathTemplate: 'api/v1/people?personIds={playerId}&season={yyyy}&hydrate=stats(group=hitting,type=season,season={yyyy},gameType={game_type:P})',
            timeout: 30,
            expires: 300,
            transformer: Transformer,
            vo: TeamLineupHittingStatsModel,
            mimetype: 'application/json'
        },
        wrapupArticleListDapi: {
            pathTemplate: '{site}-us/stories?tags.slug=gamepk-{gid}&$limit={limit:10}&$sort=contentDate:{sort:desc}',
            expires: 300,
            transformer: Transformer,
            vo: CmsDapiArticleListModel,
            mimetype: 'application/json',
            env: cmsDapiEnvs
        },
        legacyHighlights: {
            namespace: '{gid}',
            pathTemplate: 'components/game/{sportcode}/year_{yyyy}/month_{mm}/day_{dd}/gid_{gid}/media/mobile{underLang}.xml',
            transformer: Transformer,
            vo: LiesContentModel,
            mimetype: 'text/xml',
            timeout: 30,
            env: gdxEnvs
        },
        dictionary: {
            namespace: 'dictionary',
            pathTemplate: 'bdfed/contentful/dictionary/mlb-gameday/{site}-JP',
            transformer: Transformer,
            expires: false,
            mimetype: 'application/json',
            timeout: 30,
            env: stitchEnvs
        },
        socket: {
            namespace: 'websocket',
            pathTemplate: 'api/v1/game/push/subscribe/gameday/{gid}',
            env: socketEnvs
        },
        noDelaySocket: {
            namespace: 'websocket',
            pathTemplate: 'api/v1/game/push/subscribe/{gid}',
            env: socketEnvs
        }
    };
});
